<template>
  <div
    class="message"
    :class="{
      'message-my': $delve(message, 'sender.user') === receiver,
      'mb-0': !imageShown,
      'mb-6': imageShown && !isLast,
    }">
    <span v-if="isHead">{{ $delve(message, 'sender.name') }}</span>
    <div
      class="message-content"
      :class="{
        'bg-primary text-white': $delve(message, 'sender.user') === 'customer',
        'bg-secondary text-white': $delve(message, 'sender.user') === 'contractor',
        'bg-zircon text-inverse': !$delve(message, 'sender.user'),
        'rounded-t-lg': isRoundedTop,
        'rounded-br-lg': $delve(message, 'sender.user') === receiver && isRoundedBottom,
        'rounded-bl-lg': $delve(message, 'sender.user') !== receiver && isRoundedBottom,
      }">
      <div class="content-data flex flex-row items-end">
        <p class="flex-grow message-text">{{ $delve(message, 'payload.text') }}</p>
        <span class="ml-2">{{ $delve(message, 'createdAt') | date }}</span>
      </div>

      <div
        class="flex flex-row items-center flex-grow pt-2 -m-1 flex-wrap"
        v-if="message.payload.attaches.length">
        <div
          class="w-12 h-16 bg-hint rounded-sm overflow-hidden cursor-pointer m-1"
          v-for="(attach, index) in message.payload.attaches"
          :key="index"
          @click="$emit('lightbox', {
            attaches: message.payload.attaches,
            index: index,
          })">
          <Attachment
            class="h-full object-center object-cover w-full"
            :id="attach" />
        </div>
      </div>
    </div>

    <div
      class="message-img w-6 h-6 rounded-full overflow-hidden"
      :class="{
        'bg-primary': $delve(message, 'sender.user') === 'customer' && imageShown,
        'bg-secondary': $delve(message, 'sender.user') === 'contractor' && imageShown,
        'bg-zircon': $delve(message, 'sender') === null && imageShown,
      }">
      <Attachment
        :id="$delve(message, 'sender.photoAttach')"
        v-if="$delve(message, 'sender.photoAttach') && imageShown"/>
      <img
        src="@/assets/images/iwaly-icon.png"
        v-else-if="!$delve(message, 'sender') && imageShown">
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import Attachment from '@/components/global/Attachment.vue';

export default {
  props: {
    message: {
      type: Object,
      required: true,
    },
    messages: {
      type: Array,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    receiver: {
      type: String,
      validator: (value) => typeof value === 'string' || value === null,
    },
  },
  components: {
    Attachment,
  },
  computed: {
    imageShown() {
      const foundIndex = _.findIndex(
        this.messages,
        (message) => message.id === this.message.id,
      );
      const nextIndex = foundIndex + 1;

      return !this.messages[nextIndex]
        || _.get(this.messages[nextIndex], 'sender.id') !== _.get(this.message, 'sender.id');
    },

    isHead() {
      const foundIndex = _.findIndex(
        this.messages,
        (message) => message.id === this.message.id,
      );

      if (foundIndex > 1) {
        const prevIndex = foundIndex - 1;

        return !this.messages[prevIndex]
          || _.get(this.messages[prevIndex], 'sender.id') !== _.get(this.message, 'sender.id');
      }

      return this.index === 0;
    },

    isRoundedTop() {
      return this.isHead;
    },

    isRoundedBottom() {
      return this.imageShown;
    },

    isLast() {
      return this.index === this.messages.length - 1;
    },
  },
  filters: {
    date(s) {
      if (!s) return null;

      const date = moment(s);

      if (!date.isValid()) {
        return null;
      }

      return date.format('HH:mm');
    },
  },
};
</script>

<style scoped>
.message-text {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
</style>
